import { gsap, Power2, Power0 } from 'gsap';

import { Basics } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

export default class Curtain {
    static _dom = GetBy.id('Curtain');
    static _main = GetBy.selector('#Main')[0];
    static _domIconHolder = GetBy.class('icon', this._dom)[0];
    static _rotations = GetBy.class('__rotate', this._domIconHolder);
    static _scale = 0;
    static _ticker = 0;
    static isFirstTime = true;
    static _call = () => this.loop();

    static loop() {
        this._scale *= 1.004;
        this._domIconHolder.style.transform = CSS.scale3D(this._scale, this._scale, this._scale)

        this._ticker *= 1.069;
        for (let i = 0; i < this._rotations.length; i++) {
            const sign = i % 2 === 0 ? -1 : 1;
            const rot = this._rotations[i];
            rot.style.transform = `rotateZ(${sign * this._ticker}deg)`;
        }
    }

    static show(__call) {
        gsap.killTweensOf(this._dom);
        gsap.set(this._dom, { y: '101%', force3D: true });
        gsap.killTweensOf(this._domIconHolder);
        gsap.set(this._domIconHolder, { scale: 1, force3D: true });

        this._ticker = .3;
        this._scale = 1;
        this._domIconHolder.style.transform = CSS.scale3D(this._scale, this._scale, 1)

        gsap.to(this._dom, {
            y: 0,
            duration: .6,
            delay: .2,
            ease: Ease.EASE_CUCHILLO_IN_OUT,
            onComplete: () => {
                if (__call) __call();
            }
        });

        if (!this.isFirstTime) {
            this.showImages();
        }
    }

    static showImages() {
        gsap.ticker.add(this._call);

        gsap.to(this._domIconHolder, {
            alpha: 1,
            duration: .2,
            delay: .4,
            force3D: true,
            ease: Power2.easeIn
        });
    }

    static hide(__call) {
        const delay = this.isFirstTime ? 0 : .5;

        this.isFirstTime = false;
        gsap.killTweensOf(this._dom);
        gsap.killTweensOf(this._domIconHolder);

        gsap.to(this._domIconHolder, {
            alpha: 0,
            duration: .2,
            delay: delay,
            ease: Power2.easeOut
        });

        gsap.to(this._dom, {
            y: '-101%',
            duration: .6,
            delay: delay + .1,
            ease: Ease.EASE_CUCHILLO_IN_OUT,
            onComplete: () => {
                if (__call) __call();
                this.end();
            }
        });
    }

    static end() {
        gsap.ticker.remove(this._call);
    }
}
